// extracted by mini-css-extract-plugin
module.exports = {"hr":"Hr_hr__44M_I"};